/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { Box, BoxProps, ClickAwayListener } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker'
import {
  ElementType,
  MutableRefObject,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'

interface TimePickerProps extends BoxProps {
  value: Date
  handleChange: (value: Date) => void
  ariaLabel: string
  minTime?: Date
  showIcon?: boolean
  datePickerButton: ElementType
  inputLabel?: ReactNode
}
const TimePicker = ({
  value,
  handleChange,
  ariaLabel,
  minTime,
  sx,
  showIcon = false,
  datePickerButton: DatePickerButton,
  inputLabel,
}: TimePickerProps) => {
  const customInputRef = useRef() as MutableRefObject<HTMLInputElement>
  const [open, setOpen] = useState(false)
  const handleSelectTime = (date: Date | null) => {
    if (date) {
      handleChange(date)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box
          sx={{
            position: 'relative',
            ...sx,
          }}>
          <MuiTimePicker
            minTime={minTime}
            closeOnSelect
            ampm={false}
            aria-label={ariaLabel}
            value={value}
            PopperProps={{ anchorEl: customInputRef.current }}
            open={open}
            onChange={(date) => handleSelectTime(date)}
            renderInput={({ inputProps, disabled, onChange }) => (
              <div ref={customInputRef}>
                {inputLabel}
                <input
                  style={{ display: 'none' }}
                  value={value as unknown as string}
                  onChange={onChange}
                  disabled={disabled}
                  {...inputProps}
                />
                <DatePickerButton
                  open={open}
                  setOpen={setOpen}
                  value={value}
                  showIcon={showIcon}
                />
              </div>
            )}
          />
        </Box>
      </ClickAwayListener>
    </LocalizationProvider>
  )
}

export default TimePicker
